import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';

const initState = Map({
  payment: {}
});

export const { getPayment } = createActions({
  GET_PAYMENT: res => {
    return res;
  }
});

const payment = handleActions(
  {
    [getPayment]: (state, action) => {
      return state.set('payment', action.payload.data);
    }
  },
  initState
);

export default payment;
